<app-loader
	[context]="'page-content'"
	[isActive]="!detailInfo"
	#loader
>
	<div class="insurance-detail">
		@if (loader.completed) {
			<div class="product-template">
				<div class="product-template__main-information-wrapper">
					<app-page-title [pagetitle]="detailInfo.insuranceName"></app-page-title>
					<div class="product-main-info">
						<div class="product-main-info__image">
							<app-product-image
								[image]="detailInfo.image"
								[productImageParams]="{ size: CARD_PICTURE.DESKTOP }"
							></app-product-image>
						</div>
						<ul class="product-main-info__list">
							<li class="product-main-info__item">
								<span class="product-main-info__item-title">Страховая сумма</span>
								<span class="product-main-info__item-value">
									{{ detailInfo.insuranceSum | amountincurrency }}
								</span>
							</li>
							<li class="product-main-info__item">
								<span class="product-main-info__item-title">
									Период действия полиса
								</span>
								<span
									class="product-main-info__item-value product-main-info__item-value--policy-validity-period"
								>
									{{ detailInfo.beginDate | dateShortDate }} -
									{{ detailInfo.endDate | dateShortDate }}
								</span>
							</li>
						</ul>
					</div>
				</div>
				<div class="product-template__sidebar">
					<app-insurance-vertical-menu
						[detailInfo]="detailInfo"
					></app-insurance-vertical-menu>
				</div>
				<div class="product-template__other-information-wrapper">
					<div class="card-info">
						<app-accordeon
							[isOpen]="true"
							[isOpenable]="false"
						>
							<h2
								class="card-info__title"
								title
							>
								Информация о полисе страхования
							</h2>
							<div
								class="card-info__content"
								content
							>
								<ul class="requisites-list">
									<li class="requisites-list__item">
										<span class="requisites-list__item-text">
											Номер договора
										</span>
										<span class="requisites-list__item-value">
											{{ detailInfo.contractNumber }}
										</span>
									</li>
									<li class="requisites-list__item">
										<span class="requisites-list__item-text">
											Дата заключения договора
										</span>
										<span class="requisites-list__item-value">
											{{ detailInfo.beginDate | dateShortDate }}
										</span>
									</li>
									<li class="requisites-list__item">
										<span class="requisites-list__item-text">
											Дата окончания договора
										</span>
										<span class="requisites-list__item-value">
											{{ detailInfo.endDate | dateShortDate }}
										</span>
									</li>
									<li class="requisites-list__item">
										<span class="requisites-list__item-text">
											Срок действия договора
										</span>
										<span class="requisites-list__item-value">
											{{ detailInfo.contractTerm }}
										</span>
									</li>
									<li class="requisites-list__item">
										<span class="requisites-list__item-text">
											Страховые риски
										</span>
										<span class="requisites-list__item-value">
											{{ detailInfo.insuranceRisks.join(', ') }}
										</span>
									</li>
									@for (
										person of detailInfo.insuredPersons;
										track person;
										let i = $index
									) {
										<li class="requisites-list__item">
											<span class="requisites-list__item-text">
												{{ i + 1 }}ое застрахованное лицо
											</span>
											<span class="requisites-list__item-value">
												{{ person.fio }}
												{{ person.birthDate | dateShortDate }}
											</span>
										</li>
									}
									<li class="requisites-list__item">
										<span class="requisites-list__item-text">
											Email страхователя
										</span>
										<span class="requisites-list__item-value">
											{{ detailInfo.clientEmail }}
										</span>
									</li>
								</ul>
							</div>
						</app-accordeon>
					</div>
				</div>
			</div>
		}
	</div>
</app-loader>
